<template>
	<b-modal id="imc_main_modal"
			 v-bind:no-close-on-backdrop=true
			 class="modal-full-color-success"
			 title="Коригування Аватари"
			 v-model="show_modal" size="lg">

		<file-pond
			name="user_avatar"
			ref="pond"
			:server=getConfig()
			label-idle="Додати файл (натисніть або перетяніть файл)"
			v-bind:imageEditEditor="myDoka"
			v-bind:files="myFiles"
			v-on:init="handleFilePondInit"
		/>

		<template  slot="modal-footer" slot-scope="{ ok, cancel }">
			<b-button  size="xl" variant="primary-outline" class="btn btn-lg btn-outline-primary waves-effect waves-themed" @click.prevent="close_editor()">
				<span class="fal fa-check mr-1"></span>
				Готово
			</b-button>
		</template>
	</b-modal>
</template>

<script>

import  vueFilePond,{ setOptions  } from 'vue-filepond';
import { create } from '../../../../../libs/doka/doka.min.js';

import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
import FilePondPluginImageEdit from '../../../../../libs/filepond-plugin-image-edit/dist/filepond-plugin-image-edit';

import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';


import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit.min.css';


const  FilePond = vueFilePond(
	FilePondPluginFileValidateType,
	FilePondPluginImagePreview ,
	FilePondPluginImageEdit,
	FilePondPluginImageTransform,
	FilePondPluginImageResize,
	FilePondPluginImageCrop,
	//  FilePondPluginImageExifOrientation
)

setOptions({
	labelFileProcessingComplete: 'Завантаження завершено',
	labelFileProcessing : 'Завантажуємо',
	labelTapToUndo : 'Натисніть щоб видалити',
	labelInvalidField :'Файл містить заборонений тип',
	// imageCropAspectRatio: '1:1',
	//     imageResizeTargetWidth: 600,
	//    imageResizeTargetHeight: 600,
	//  styleLoadIndicatorPosition: 'center bottom',

});

export default {
	name: "avatar_modal",
	components: {
		FilePond,
	},
	props : {
		trigger_load: {
			type: String,
			default: 'saved_user_avatar',
		},
	},
	data () {
		return {
			show_modal : false,
			user_id : 0,
			myFiles: [

			],
			myDoka: {},
		}
	},

	created() {
		EventBus.$on('edit_avatar',this.on_edit)
	},
	methods : {
		on_edit(image,user_id) {
			this.handleFilePondInit();
			this.myFiles = [];
			if(image != null) {
				if(image.hasOwnProperty('real_info')) {
					let avatar = {
						source :  image.real,
                        metadata: {
                            poster: image.real
                        },
						options : {
							type : "local"
						},

						file: {
							name: image.real_info.name,
							size: image.real_info.size,
							type: image.real_info.type
						},
					}

					this.myFiles.push(avatar);
				}
			}
			this.user_id = user_id;
			this.show_modal = true;
		},

		getConfig () {
			let token = getCookie('IMC_API')
			return {
				url: '',
				timeout: 7000,

				process: {
					url: 'https://api-zozenko.timc.biz/api/v1/user/' + this.user_id + "/avatar",
					method: 'POST',
					headers: {
						'Authorization': 'Bearer ' + token
					},
					withCredentials: false,
					onload: (response) => {
						let load_result = JSON.parse(response);
						EventBus.$emit('avatar_finish_load',load_result);
						return response.key
					},
					onerror: (response) => response.data,
					ondata: (formData) => {
						console.log(formData);
						formData.append('user_id', this.user_id);
						return formData;
					}
				},

				revert: {
					url: 'https://api-zozenko.timc.biz/api/v1/user/' + this.user_id + "/avatar",
					method: 'DELETE',
					headers: {
						'Authorization': 'Bearer ' + token
					},
					withCredentials: false,
					onload: (response) => {
						EventBus.$emit('avatar_del',response);
						return response.key
					},
					onerror: (response) => response.data,
					ondata: (formData) => {
						console.log(formData);
						formData.append('user_id', this.user_id);
						EventBus.$emit('avatar_deleted',formData);
						return formData;
					}
				},
				restore: null,
				load: (src, load) => {
                    fetch(src)
                        .then(res => res.blob())
                        .then(load);
                },
				fetch: null
			}
		},
		handleFilePondInit() {

			this.myDoka = create({
				// doka options here
				labelStatusAwaitingImage: 'Чекаємо на аватар…',
				labelStatusLoadImageError: 'Помилка…',
				labelStatusLoadingImage: 'Завантажуємо…',
				labelStatusProcessingImage: 'Працюємо над аватаром…',
				labelButtonConfirm : 'Зберегти',
				labelButtonClose :'Скасувати',
				labelButtonCropRotateLeft :"Повернути вліво",
				labelButtonCropRotateRight: 'Повернути вправо',
				labelButtonCropFlipHorizontal:'Зеркало горизонтально',
				labelButtonCropFlipVertical:'Зеркало вертикально',
				utils :['crop', 'filter', 'color', 'resize'],
				cropShowSize:true,
				outputWidth:250,
				outputHeight : 250,

				onconfirm : (data,image) => {
					image.abortLoad();
				}

			});

			let self = this;

			this.myDoka.on('confirm',e => {
				console.log('Image edited', e);
				self.save_doka(e.file);
			});
		},
		save_doka(file) {

			let self = this;
            console.log(file);
			if(file != null) {
				const formData = new FormData();
				formData.append('user_avatar', file, file.name);
				formData.append("user_id", this.user_id);
				let token = getCookie('IMC_API')
				const request = new XMLHttpRequest();
				request.open('POST', 'https://api-zozenko.timc.biz/api/v1/user/' + this.user_id + '/avatar_thumb');
				request.setRequestHeader('Authorization', 'Bearer ' + token);
				request.setRequestHeader('Accept', 'application/json');

				request.onload = function () {
					console.log(request);
					let load_result = JSON.parse(request.responseText);
					EventBus.$emit('avatar_finish_load',load_result);

					self.close_editor();
					self.myFiles = [];
				};
				request.send(formData);
			}
		},

		close_editor() {
			this.show_modal = false;
			EventBus.$emit(this.trigger_load);
		},
	}
}
</script>

<style scoped>

</style>
